import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import React from 'react';
import { StakeholderSelector } from '@ui/StakeholderSelector';
import { useAction, useOnMount, useSonarObjectReference } from '@hooks';
export const SonarObjectStakeholders = ({ getPopupContainer, isSpreadsheet, sonarObjectId, withLatest, direction }) => {
    var _a, _b;
    const stakeholders = (_b = (_a = useSonarObjectReference(sonarObjectId)) === null || _a === void 0 ? void 0 : _a.stakeholders) !== null && _b !== void 0 ? _b : [];
    const getBusinessContextStakeholders = useAction(coreActions.requestGetCoreSonarObjectsStakeholders);
    const updateBusinessContextStakeholders = useAction(coreActions.requestPutCoreSonarObjectsStakeholders);
    useOnMount(() => {
        if (withLatest) {
            getBusinessContextStakeholders({ sonarObjectId });
        }
    });
    const handleChange = (stakeholderIds) => {
        updateBusinessContextStakeholders({
            sonarObjectId,
            stakeholderIds
        });
    };
    return (React.createElement(StakeholderSelector, { avatar: true, direction: direction, getPopupContainer: getPopupContainer, isSpreadsheet: isSpreadsheet, mode: 'multiple', onChange: handleChange, placeholder: COPY_SPECIFIC.ADD_STAKEHOLDERS, value: stakeholders }));
};
